/**
 * @fileoverview Resource-related route definitions. Detail routes for individual
 * resources (the `resources/:resourceId` notes-browse hierarchy) live in
 * notesRoutes.tsx; this file adds the hub listing page.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';

const ResourcesHubPage = lazy(() => import('../../features/resources/pages/ResourcesHubPage'));

export const resourcesRoutes: RouteObject[] = createRoutes([
  { path: 'resources', Component: ResourcesHubPage },
]);
